export default "__VITE_ASSET__P_Lkn6jT__"